module.exports = __webpack_public_path__ + "static/media/leave.769f1c53.svg";